module.exports = __webpack_public_path__ + "img/172.1df71e41.jpg";